import React, { useEffect } from 'react';

import { BasicSelector, BasicSelectorProps } from './basic-selector';
import { IBuilding } from '../../models';

type BuildingAreaSelectorProps = BasicSelectorProps & {
  building: IBuilding;
  value: number | null;
  onChange?: (value: number | null) => void;
};

export const BuildingAreaSelector = ({
  building,
  onChange: _onChange = () => {},
  value,
  ...rest
}: BuildingAreaSelectorProps) => {
  const label = 'Building area';
  const optionsLoadingText = 'Loading zone categories';

  const [options, setOptions] = React.useState<number[]>([]);
  const getOptionLabel = React.useCallback(
    (option: number) => building.areas?.find(({ id }) => id === option)?.name || '',
    [building.areas],
  );
  const onChange: any = (_: any, value: number) => _onChange(value);

  useEffect(() => {
    const label = getOptionLabel(value);

    if (!label) {
      _onChange(null);
    }
  }, [value]);

  useEffect(() => {
    const o = building.areas?.map((area) => area.id as number) ?? [];
    setOptions(o);
  }, [building.areas]);

  const componentProps: Partial<BuildingAreaSelectorProps> = {
    label,
    optionsLoadingText,
    value,
    options,
    getOptionLabel,
    onChange,
    optionsConfig: false,
  };

  return <BasicSelector {...componentProps} {...rest} />;
};
